export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/viewer/img_page_viewer_left-9dfcfb95181f74c2904269a174bccc62.gif";